"use strict";

var fs = null;
try {
    fs = require(11);
    if (!fs || !fs.readFile || !fs.readFileSync)
        fs = null;
} catch (e) {
    // `fs` is unavailable in browsers and browser-like bundles.
}
module.exports = fs;
